module.exports = __webpack_public_path__ + "static/media/resource-6@3x.37eb083f.jpg";